<script setup lang="tsx">
const { t } = useI18n();
const device = useDevice();
const cookieManagement = useCookieManagement();
const displayed = ref(false);

watch(cookieManagement.cookieBannerLocalStorage, (value) => {
  displayed.value = value === null;
});

displayed.value = cookieManagement.cookieBannerLocalStorage.value === null;

function onButtonTap(value: boolean) {
  cookieManagement.cookieBannerLocalStorage.value = String(value);
  cookieManagement.checkCookieConsent(); // This is to update the PostHog config
  displayed.value = false;
}

const accordionItems = computed(() => [
  {
    label: t("cookies.modal.consent.additional_info"),
    icon: "i-heroicons-information-circle",
    defaultOpen: false,
    slot: "additional-info",
  },
]);

const actions = computed(() => [
  {
    label: t("cookies.modal.consent.button.reject"),
    click: () => onButtonTap(false),
    variant: "outline",
    color: "primary",
    block: device.isMobile,
  },
  {
    label: t("cookies.modal.consent.button.accept"),
    click: () => onButtonTap(true),
    variant: "solid",
    color: "primary",
    block: device.isMobile,
  },
]);
</script>

<template>
  <div
    v-if="displayed"
    class="fixed left-1/2 -translate-x-1/2 bottom-16 sm:bottom-32 pb-safe w-full max-w-lg p-4 z-50"
  >
    <UNotification
      :id="Math.random().toString()"
      :close-button="{
        class: 'hidden',
      }"
      :actions="actions"
      :title="$t('cookies.modal.consent.title')"
      :description="$t('cookies.modal.consent.message')"
      :timeout="0"
      :ui="{
        actions: 'justify-end max-sm:flex-col-reverse',
        title: 'text-lg font-semibold',
        description: 'leading-5',
        transition: {
          enterFromClass:
            'translate-y-2 opacity-0 sm:translate-y-0 sm:translate-y-2',
          enterToClass: 'translate-y-0 opacity-100 sm:translate-y-0',
        },
      }"
    >
      <template #description="{ description }">
        <div class="space-y-4">
          <p v-html="description"></p>

          <UAccordion
            :items="accordionItems"
            :ui="{
              item: {
                padding: 'pt-0 pb-0',
              },
              default: {
                class: 'mb-0',
              },
            }"
          >
            <template #additional-info>
              <div class="text-sm p-2">
                <div
                  class="flex justify-between py-2 border-b border-gray-200 dark:border-gray-700"
                >
                  <span class="font-semibold">Supabase</span>
                  <span>{{ $t("cookies.modal.consent.essential") }}</span>
                </div>
                <div class="flex justify-between py-2">
                  <span class="font-semibold">PostHog</span>
                  <span>{{ $t("cookies.modal.consent.optional") }}</span>
                </div>

                <div class="mt-4">
                  <a
                    :href="useRuntimeConfig().public.iubendaCookieUrl"
                    class="hover:underline text-primary-500"
                    >{{ $t("cookies.modal.consent.button.cookie_policy") }}</a
                  >
                </div>
              </div>
            </template>
          </UAccordion>
        </div>
      </template>
    </UNotification>
  </div>
</template>
